import React, { Component } from 'react'

import Select from 'react-select'
import 'react-select/dist/react-select.css';

const style = {
	backgroundColor: '#fff'
}
export default props => (
	<div>
	  <Select
	    className="react-select"
	    value={props.input.value}
	    onChange={ props.input.onChange }
	    onBlur={() => props.input.onBlur(props.input.value)}
	    options={props.options}
	    placeholder={props.placeholder || 'Please select'}
	    simpleValue

	    valueKey={props.valueKey || "value" }
			labelKey={props.labelKey || "label" }
	  />
	  { (props.meta.touched && props.meta.error) && <span className="form-error is-visible" id="uuid">{props.meta.error}</span> }
	</div>
)


// WEBPACK FOOTER //
// ./src/components/ui/SelectComponent.js